export const immunityEffects = {
  invulnerable: {
    priority: 5,
    disable: ['stun', 'sleep', 'root', 'slow', 'silence', 'disarm', 'hex', 'fear', 'taunt', 'lure'],
    resources: {}
  },
  unstoppable: {
    priority: 3,
    disable: ['stun', 'sleep', 'root', 'slow', 'silence', 'disarm', 'hex', 'fear', 'taunt', 'lure'],
    resources: {}
  }
} as const;
